import { globalTrackerAPIRoot, oxfordStringencyAPIRoot } from 'Constants/locations';
import { useEffect, useState } from 'react';

import App from './App';
import fetchJson from 'Utils/fetchJson';

const PageRoot = (props) => {
  const { region } = props;

  const [globalStatistics, setGlobalStatistics] = useState(props.globalStatistics);
  const [regionalStatistics, setRegionalStatistics] = useState(props.regionalStatistics);
  const [regionalCounts, setRegionalCounts] = useState(props.regionalCounts);
  const [oxfordStringency, setOxfordStringency] = useState(null);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    setHasFetched(false);
  }, [region]);

  useEffect(() => {
    const refetchData = async() => {
      const [
        globalStatistics,
        regionalStatistics,
        regionalCounts,
        oxfordStringency,
      ] = await Promise.all([
        fetchJson(`${globalTrackerAPIRoot}/statistics.json`),
        fetchJson(`${globalTrackerAPIRoot}/regions/${region}/statistics.json`),
        fetchJson(`${globalTrackerAPIRoot}/regions/counts/all.json`),
        fetchJson(`${oxfordStringencyAPIRoot}/${region}/data.json`),
      ]);

      setGlobalStatistics(globalStatistics);
      setRegionalStatistics(regionalStatistics);
      setRegionalCounts(regionalCounts);
      setOxfordStringency(oxfordStringency);
      setHasFetched(true);
    };
    refetchData();
  }, [region]);

  // temp very nuclear fix for basePath app when getStaticProps doesn't run...
  // if (!props.globalStatistics) location.reload();

  return (
    <App {...{
      ...props,
      globalStatistics,
      regionalStatistics,
      regionalCounts,
      oxfordStringency,
      hasFetched,
      publicPrefix: process.env.NODE_ENV === 'production' ? '' : '',
    }}
    />
  );
};

export default PageRoot;
